import {
  getParent,
  types,
  flow
} from 'mobx-state-tree';
import Playlist from './Playlist';

const URL = 'education-center/v1';

const Section = types.model('section',{
  id: types.optional(types.string, ''),
  title: types.optional(types.string, ''),
  language: types.optional(types.string, ''),
  type: types.optional(types.string, ''),
  displayIndex: types.optional(types.number, 0),
  deleted: types.optional(types.boolean, false),
  playlists: types.optional(types.array(Playlist),[]),
  searchResultParentIndex: types.maybe(types.number),
  activePlaylists: types.optional(types.array(types.string), []),
  availableLanguages: types.optional(types.array(types.string), [])
}).views(self => ({
  get transport5007() {
    return getParent(self,2).transport5007;
  },
  get filteredPlaylists() {
    if(typeof self.searchResultParentIndex !== 'number') {
      return [];
    }
    return self.playlists.filter(({id}) => {
      // look in the searchResults if there is any item with the current playlist's id
      return self.searchResults.find(sect => sect.playlistId === id);
    })
  },
  get searchResults() {
    if(typeof self.searchResultParentIndex !== 'number') {
      return [];
    }
    return getParent(self,2).searchResults[self.searchResultParentIndex] ? getParent(self,2).searchResults[self.searchResultParentIndex].playlists : [];
  }
})).actions(self=>({
  loadPlaylist(playlistId, afterPlaylistLoaded=null) {
    self.playlists.forEach(playlist => {
      if(playlist.id === playlistId) {
        playlist.loadVideos(afterPlaylistLoaded);
      }
    })
  },
  setActivePlaylists(activeKey) {
    self.activePlaylists=activeKey;
  },
  setLanguage(language){
    self.language=language;
  },
  setAllFilteredVideos(){
    self.filteredPlaylists.forEach(playlist =>{
      // make sure the filtered playlists are loaded
      self.loadPlaylist(playlist.id, ()=>{
        // look in the searchResults for the item with the current playlist's id
        const resultPlaylistIndex = self.searchResults.findIndex(pl => pl.playlistId === playlist.id);
        // save the list of videos in the current playlist
        if(self.searchResults[resultPlaylistIndex]){
          playlist.setVideoResultsParentIndex(resultPlaylistIndex);
        }
      });
    })
  },
  setPlaylistResultsParentIndex(searchResultParentIndex) {
    self.searchResultParentIndex = searchResultParentIndex;
    self.setAllFilteredVideos();
    // open all the playlists
    self.setActivePlaylists(self.filteredPlaylists.map(({id}) => id))
  },
  closePlaylists() {
    self.setActivePlaylists([]);
  },
  fetchSection: flow(function* fetchSection(typeChanged,languageChanged) {
    try {
      const { data } = yield self.transport5007.fetch(
        `${URL}/Sections/${typeChanged}/${languageChanged}`,
        {},
        {}
      );
      self.id=data.id;
      self.availableLanguages=data.availableLanguages;
      self.deleted=data.deleted;
      self.displayIndex=data.displayIndex;
      self.language=data.language;
      self.playlists=data.playlists;
      self.title=data.title;
      self.type=data.type;
    } catch (error) {
      console.error('Getting Sections failed: ', error);
    }
  }),
}));

export default Section;
